import React from 'react';
import StartingForm from '../StartingForm.jsx';

export default function HomePage() {
    return (
        <>
            <StartingForm />
        </>
    )
} 
